module.exports = __webpack_public_path__ + "static/img/5.2b50367.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/eng/5.png
// module id = 0ln8
// module chunks = 0